import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Register.vue')
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../views/Profile.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/rumors',
    name: 'Rumors',
    component: () => import('../views/Rumors.vue')//政策
  },
  {
    path: '/rumors/:id',
    name: 'RumorDetail',
    component: () => import('../views/RumorDetail.vue')//政策里的详情
  },
  {
    path: '/knowledge',
    name: 'KnowledgePage',
    component: () => import('../views/Knowledge.vue')//谣言
  },
  {
    path: '/knowledge/:id',
    name: 'KnowledgeDetail',
    component: () => import('../views/KnowledgeDetail.vue')//404
  },
  {
    path: '/laws',
    name: 'LawsPage',
    component: () => import('../views/Laws.vue')
  },
  {
    path: '/laws/:id',
    name: 'LawDetail',
    component: () => import('../views/LawDetail.vue')
  },
  {
    path: '/naws',
    name: 'Naws',
    component: () => import('../views/Naws.vue')
  },
  {
    path: '/workList',
    name: 'WorkList',
    component: () => import('../views/workList.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('user')
  
  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
    next('/login')
  } else {
    next()
  }
})

export default router 